import {
  GoalPosition,
  PitchDistance,
  PitchPosition,
} from '@collector/mobile-feature-goal-and-pitch-positions'
import { HandballAttributeId } from '@collector/sportsapi-client-legacy'
import { ProbableIncident } from '@mobile/ActionQueue/Actions/Incidents/ProbableIncident'
import { IncidentDetailsFillState } from '@mobile/views/Relation/DetailsPanel/enums'

function makeFillStateGetter<T>(attributeMap: Map<T, HandballAttributeId>) {
  return (incident: ProbableIncident): IncidentDetailsFillState => {
    const attributes = incident.attribute_ids as HandballAttributeId[]

    const fillState = Array.from(attributeMap.entries()).some(
      ([_, attribute]) => attributes.includes(attribute),
    )
      ? IncidentDetailsFillState.Filled
      : IncidentDetailsFillState.NotFilled

    return fillState
  }
}

export function getPitchDistanceFillState(
  incident: ProbableIncident,
  distanceAttributeMap: Map<PitchDistance, HandballAttributeId>,
): IncidentDetailsFillState {
  return makeFillStateGetter(distanceAttributeMap)(incident)
}

export function getPitchPositionFillState(
  incident: ProbableIncident,
  positionAttributeMap: Map<PitchPosition, HandballAttributeId>,
): IncidentDetailsFillState {
  return makeFillStateGetter(positionAttributeMap)(incident)
}

export function getGoalPositionFillState(
  incident: ProbableIncident,
  goalPositionAttributeMap: Map<GoalPosition, HandballAttributeId>,
): IncidentDetailsFillState {
  return makeFillStateGetter(goalPositionAttributeMap)(incident)
}
